(function () {
  var syncTimer = null;
  var wired = false;

  function syncCheckoutAmount() {
    var drawer = document.querySelector("m-cart-drawer");
    if (!drawer) return;

    var subtotal = drawer.querySelector("[data-cart-subtotal-price]");
    var amount = drawer.querySelector("[data-gratia-cart-checkout-amount]");
    if (!subtotal || !amount) return;

    var value = subtotal.textContent.trim();
    if (amount.textContent.trim() !== value) {
      amount.textContent = value;
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCheckoutAmount, 0);
  }

  function subscribeCartEvents() {
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return;

    var events = window.MinimogTheme.pubSubEvents;
    if (events.cartUpdate) window.MinimogEvents.subscribe(events.cartUpdate, scheduleSync);
    if (events.openCartDrawer) window.MinimogEvents.subscribe(events.openCartDrawer, scheduleSync);
  }

  function wireOnce() {
    if (wired) return;
    wired = true;

    document.addEventListener("cart:updated", scheduleSync);
    document.addEventListener("product-ajax:added", scheduleSync);
    subscribeCartEvents();

    var drawer = document.querySelector("m-cart-drawer");
    if (drawer && window.MutationObserver) {
      new window.MutationObserver(scheduleSync).observe(drawer, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    scheduleSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireOnce);
  } else {
    wireOnce();
  }
})();
